import { ButtonBasic, TextareaDynamicPlaceholder, ButtonClose } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../../TitlePage/TitlePage';
import { ModalComponent } from "../../ModalComponent/ModalComponent";
import './ModalAddPrompt.scss'

const ModalAddPrompt = ({
    createRule,
    prompt,
    setPrompt,
    setIsModal
}) => {

    return (
        <ModalComponent
            onClose={(e) => setIsModal(false)}
            title='Добавить свой промт для ИИ'
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-add-prompt-v2'>
                    <TextareaDynamicPlaceholder
                        width='100%'
                        changeValue={prompt}
                        placeholder={'Введите текст'}
                        onChange={setPrompt}
                    />

                    <div className='modal-add-prompt-v2__group-btn'>
                        <ButtonBasic
                            grey
                            text='Отмена'
                            width='100%'
                            onClick={(e) => setIsModal(false)}
                        />

                        <ButtonBasic
                            green
                            text='Сохранить'
                            width='100%'
                            onClick={(e) => {
                                createRule()
                                setTimeout(() => setIsModal(false), 500)
                            }}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalAddPrompt }